import { AlluvialChart } from "@client/components/round/allocator/AlluvialChart/AlluvialChart";
import { MainRoot } from "@client/pages/round/allocator/Aggregator";
import { SProcessOutput } from "@lib/algoInterface/runSProcessOnRound";

export function SankeyPage({
  results,
  readyStatus,
}: {
  results: SProcessOutput;
  readyStatus: { isReady: boolean; reasonsWhyNot: string[] };
}) {
  return (
    <MainRoot>
      {!readyStatus.isReady && (
        <div>{`Can't run round: ${readyStatus.reasonsWhyNot.join("; ")}`}</div>
      )}
      <div className="flex flex-1 flex-col select-none overflow-x-hidden">
        {results && <AlluvialChart results={results} />}
      </div>
    </MainRoot>
  );
}
